import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Función interna para precargar una lista de videos
function preload(slugs) {
  slugs.forEach(slug => {
    const video = document.createElement('video');
    video.src = `public/video/thumbs/${slug}.mp4`; // Asume que los videos están en /public/videos/
    video.preload = 'auto';
  });
}

// Función exportada que configura el ScrollTrigger
export function preloadVideos(triggerSelector, videoSlugs) {
  // console.log(videoSlugs);
  // Nos aseguramos de que el elemento disparador exista
  if (!document.querySelector(triggerSelector)) {
    return;
  }

  ScrollTrigger.create({
    trigger: triggerSelector,
    start: 'top bottom', // Se activa cuando la parte superior del trigger toca el borde inferior de la pantalla
    once: true,          // Se ejecuta solo una vez
    onEnter: () => setTimeout(() => preload(videoSlugs), 1800), // Llama a la función de precarga
  });
}

export function setAutoplayInDialog() {
  // Esta función ya no añade autoplay automáticamente a todos los videos
  // El autoplay se maneja individualmente cuando se abre cada modal
  // Esto previene que todos los videos se reproduzcan simultáneamente
  // console.log('Video autoplay será manejado por el sistema de modales');
}